/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ParticipationInputs */

const en__field_participation = /** @type {(inputs: _Field_ParticipationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participation`)
};

const de__field_participation = /** @type {(inputs: _Field_ParticipationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahme`)
};

/**
* | output |
* | --- |
* | "Participation" |
*
* @param {_Field_ParticipationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_participation = /** @type {((inputs?: _Field_ParticipationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ParticipationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participation(inputs)
	return de__field_participation(inputs)
});